import {
  BooleanField,
  Labeled,
  ReferenceField,
  SelectField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useShowController,
} from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";

import { settings } from "app";

import { administrationRequests } from "api/administrationApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { GenderOptionsId } from "utils/choices";
import { getAvailability } from "components/CareerCenter/helpers";
import { careerCenterRequests } from "api/careerCenterApi";
import ApproveAlumniProfile from "components/Alumni/AlumniProfiles/ApproveAlumniProfile";
import RejectAlumniProfile from "components/Alumni/AlumniProfiles/RejectAlumniProfile";
import ReturnAlumniProfileForCorrection from "components/Alumni/AlumniProfiles/ReturnAlumniProfileForCorrection";

const ShowAlumni = () => {
  //Avatar imageId, imageIds
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { record } = useShowController();

  const { isAvailableForCorrection, isAvailableForApprove, isAvailableForReject } = getAvailability(record?.status);

  return (
    <Show
      title="Детайли на алумни"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          {isAvailableForApprove && (
            <SecuredComponent permission={permissions.canManageAlumni}>
              <ApproveAlumniProfile />
            </SecuredComponent>
          )}
          {isAvailableForReject && (
            <SecuredComponent permission={permissions.canManageAlumni}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems={"center"}
                pb={1}
              >
                <RejectAlumniProfile />
              </Box>
            </SecuredComponent>
          )}
          {isAvailableForCorrection ? (
            <SecuredComponent permission={permissions.canManageAlumni}>
              <ReturnAlumniProfileForCorrection />
            </SecuredComponent>
          ) : null}
          <BackButtonToolbar />
        </TopToolbar>
      }
    >
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Typography
              color="secondary"
              fontWeight={"bold"}
            >
              Лични данни
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Име">
              <TextField source="firstName" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Презиме">
              <TextField source="secondName" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Фамилия">
              <TextField source="lastName" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Пол">
              <SelectField
                choices={GenderOptionsId}
                source="gender"
              />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Имейл">
              <TextField source="email" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Телефон">
              <TextField source="contactPhone" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Статус">
              <ReferenceField
                source="status"
                reference={careerCenterRequests.getStatusesSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Typography
              color="secondary"
              fontWeight={"bold"}
            >
              Данни за профила
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Година на семестриално завършване">
              <TextField source="semesterCompletionYear" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Година на дипломиране">
              <TextField source="diplomaYear" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Специалност">
              <ReferenceField
                label="Специалност"
                source="specialtyId"
                reference={administrationRequests.getSpecialitiesSelect()}
              >
                <TextField
                  label="Име"
                  source="name"
                  emptyText="-"
                />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Група, с която е завършил">
              <TextField source="group" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Месторабота">
              <TextField source="currentEmployer" />
            </Labeled>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Съгласен съм да получавам информация за събития организирани от МУ - София">
              <BooleanField source="consentToReceiveInfo" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Съгласен съм, данните ми да бъдат споделяни с хора завършили същата специалност в същата година">
              <BooleanField source="consentToShareProfile" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Съгласен съм да участвам в събития организирани от МУ - София">
              <BooleanField source="consentToParticipateInEvents" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowAlumni;
